import NotFound from "../pages/NotFound";
import { useAuth } from "../hooks/useAuth";

// Gate for the private provider surface. The issue calls for a 404 (not a
// 403) when a non-provider hits the route, so we render `NotFound` in-place
// rather than redirecting — the URL stays as the user typed it but no
// content is leaked.
export default function ProviderRoute({ children }) {
  const { user, profile, loading } = useAuth();
  if (loading) return <div className="page-loading">Cargando...</div>;
  if (!user || profile?.role !== "provider_admin") return <NotFound />;
  return children;
}
